/** Boot: pick the data adapter, load the household, start the router. */
import './styles/app.css';
import { api } from './lib/api';
import { Img } from './lib/images';
import { setRoute } from './lib/nav';
import { S } from './lib/state';
import { toast } from './lib/ui';
import { render, wireEvents } from './router';

async function boot() {
  const params = new URLSearchParams(location.search);
  const wantDemo = params.get('demo') === '1';
  // Routing: use the hash when the browser lets us; fall back to memory in sandboxed viewers.
  let hash = '';
  try { hash = location.hash; } catch {}
  setRoute(hash && hash !== '#' ? hash : null);
  await Img.open();
  wireEvents();

  if (wantDemo) await useLocal();
  else {
    try { S.mode = 'remote'; await api.bootstrap(); }
    catch (e: any) {
      // No server behind us (plain `vite dev`, or the file opened directly): run the in-browser demo.
      console.warn('API unreachable, switching to local demo mode:', e?.message);
      await useLocal();
    }
  }
  if (params.get('expired') === '1' || /expired=1/.test(hash)) { S.ui.flash = 'That sign-in link has expired or was already used. Send a new one.'; S.ui.signedOut = true; }
  if (!hash || hash === '#' || hash === '#/') setRoute(S.ui.signedOut ? '#/signin' : '#/setup');
  render();
  if (S.mode === 'local' && !wantDemo) toast('Demo mode: data stays in this browser');
}
async function useLocal() {
  const { LocalAdapter, sweepHolds } = await import('./lib/local');
  S.mode = 'local'; api.adapter = LocalAdapter;
  await api.bootstrap();
  sweepHolds();
  setInterval(() => { sweepHolds(); }, 60_000);
}
boot().catch(e => { console.error(e); document.getElementById('view')!.innerHTML = `<div class="pad"><h1>Could not start</h1><pre class="code">${String(e?.stack || e)}</pre></div>`; });
